import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../../constants/path';
import { CONTEXT_ROOT, HIDE_ALO } from '../../../../constants';
import { IBAN_TYPE_PERSONNAL } from '../../../../services/account/iban/constants';

import { reset, setTimeoutId } from '../../../../services/account/iban/actions';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import AloComponent from '../alo/AloComponent';
import HeadComponent from '../../../HeadComponent';
import IbanFormComponent from './IbanFormComponent';
import IbanListComponent from './IbanListComponent';
import ProfileFormComponent from './ProfileFormComponent';
import LinkButtonComponent from '../../../button/LinkButtonComponent';
import SuccessMessageComponent from '../../../form-message/SuccessMessageComponent';

import './ProfilePage.scss';

export class ProfilePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showForm: false };
    }

    componentDidUpdate(prevProps) {
        const { createIbanSuccess, deleteIbanSuccess } = this.props;

        if (
            (!prevProps.createIbanSuccess && createIbanSuccess) ||
            (!prevProps.deleteIbanSuccess && deleteIbanSuccess)
        ) {
            this.setState({ showForm: false });
        }
    }

    componentWillUnmount() {
        const { reset, timeoutId } = this.props;

        clearTimeout(timeoutId);
        reset();
    }

    handleClick = () => {
        this.setState({
            showForm: !this.state.showForm
        });
    };

    handleKeyDown = e => {
        if (e.key === 'Enter') {
            this.handleClick();
        }
    };

    handleCloseMessage = () => {
        const { reset, timeoutId } = this.props;
        clearTimeout(timeoutId);
        reset();
    };

    render() {
        const { i18n, i18nIban, i18nAlo, createIbanSuccess, deleteIbanSuccess } = this.props;

        return (
            <div id="p-compte-monprofil">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.ACCOUNT_PROFILE_PATH}`}
                />
                <h2>{i18n.SUBTITLE_PERSONNAL_INFORMATION}</h2>
                <ProfileFormComponent />

                <IbanListComponent type={IBAN_TYPE_PERSONNAL} />
                <div className="account-button">
                    <span
                        id="add-account-button"
                        title={i18nIban.ADD_NEW_ACCOUNT}
                        aria-label={i18nIban.ADD_NEW_ACCOUNT}
                        aria-expanded={this.state.showForm}
                        role="button"
                        tabIndex="0"
                        onClick={this.handleClick}
                        onKeyDown={this.handleKeyDown}>
                        <span className="plus">+</span>
                        <span className="text">{i18nIban.ADD_NEW_ACCOUNT}</span>
                    </span>
                </div>
                {this.state.showForm && (
                    <React.Fragment>
                        <p className="new-account">{i18nIban.NEW_ACCOUNT}</p>
                        <IbanFormComponent type={IBAN_TYPE_PERSONNAL} />
                    </React.Fragment>
                )}
                <SuccessMessageComponent
                    visible={createIbanSuccess}
                    message={i18nIban.CREATE_IBAN_SUCCESS}
                    onClose={this.handleCloseMessage}
                />
                <SuccessMessageComponent
                    visible={deleteIbanSuccess}
                    message={i18nIban.DELETE_IBAN_SUCCESS}
                    onClose={this.handleCloseMessage}
                />

                {!HIDE_ALO && (
                    <React.Fragment>
                        <h3>{i18n.SUBTITLE_ALO}</h3>
                        <div className="alo-button">
                            <p>{convertHtmlToReactDomWithParams(i18nAlo.ALO_TEXT)}</p>
                            <LinkButtonComponent
                                to={PATH.ALO_PATH}
                                text={i18nAlo.ALO_BUTTON}
                                title={i18nAlo.ALO_BUTTON}
                                color="sixth"
                            />
                        </div>
                        <AloComponent />
                    </React.Fragment>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.PROFILE,
        i18nIban: state.i18n.page.ACCOUNT.PROFILE.IBAN,
        i18nAlo: state.i18n.page.ACCOUNT.ALO,
        i18nForm: state.i18n.feature.form,
        createIbanSuccess: state.account.iban.createIbanSuccess,
        deleteIbanSuccess: state.account.iban.deleteIbanSuccess
    };
};

const mapDispatchtoProps = {
    reset,
    setTimeoutId
};

export default connect(mapStateToProps, mapDispatchtoProps)(ProfilePage);



// WEBPACK FOOTER //
// ./src/components/pages/account/myprofile/ProfilePage.js